var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PopUpPict"},[_c('div',{staticClass:"PopUpFon",on:{"click":_vm.hide}}),_c('div',{staticClass:"PhotoShow",style:({ 'background-image': `url(${_vm.picture.picture})` }),on:{"click":_vm.hide}}),_c('div',{staticClass:"PhotoTxt"},[_vm._v(_vm._s(_vm.picture.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }